module.exports = __webpack_public_path__ + "static/media/City Life - Bordeaux_PW Pink.b3e511aa.jpg";